import React, { useContext } from 'react';

import styled from 'styled-components';
import NavSideBarContext from '../../contexts/NavSideBarContext';
import NavItem from './NavItem';
import { buildSettings } from '../../navigation/appRoutes';
import ImpersonatorBanner from '../../components/NavigationSideBar/ImpersonatorBanner';
import PERMISSIONS from '../../permissionDefinitions';
import PermissionGates from 'components/PermissionGates';
import NotificationsButton from './NotificationsButton';
import ProfileButton from './ProfileButton';
import OnlyAdminPortal from '../../components/OnlyAdminPortal';
import { PortalsContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import PortalPreviewButton from './PortalsPreviewButton';
import V1AccountsOnly from '../../components/V1AccountsOnly';
import NewUiPreviewBanner from '../../components/NavigationSideBar/NewUiPreviewBanner';
import HelpCenterButton from '../../components/NavigationSideBar/HelpCenterButton';
import TodayOverrideOverlay from '../../navigation/Authenticated/V3/Common/TodayOverrideOverlay';

const MainNavBottomDiv = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.isOpen ? 'row' : 'column')};
  border-top: solid 1px var(--color-border-secondary);
  justify-content: center;
  align-items: ${(props) => (props.isOpen ? 'center' : 'stretch')};
  background-color: var(--color-bg-secondary);
  padding: 8px 0px;

  a {
    margin-right: ${(props) => (props.isOpen ? '8px' : '0px')};
  }
`;

const SETTINGS_PERMISSIONS = [
  PERMISSIONS.BILLING.VIEW_BILLING,
  PERMISSIONS.DATA_MANAGEMENT.INTEGRATIONS_CONFIG_VIEW,
  PERMISSIONS.DATA_MANAGEMENT.INTEGRATIONS_CONFIG_MODIFY,
  PERMISSIONS.USER_MANAGEMENT.VIEW_USER,
];

const MainNavBottom = ({
  isSettingsHidden,
}: {
  isSettingsHidden?: boolean;
}) => {
  const { selectedPortal, isPortalUIToggleEnabled } =
    useContext(PortalsContext);
  const { isOpen } = useContext(NavSideBarContext);

  return (
    <div>
      {isOpen && <NewUiPreviewBanner isOpen={true} />}
      <TodayOverrideOverlay />
      <ImpersonatorBanner isOpen={isOpen} />
      <MainNavBottomDiv isOpen={isOpen}>
        {!isSettingsHidden && (
          <OnlyAdminPortal>
            <PermissionGates.HasAny requiredPermissions={SETTINGS_PERMISSIONS}>
              <NavItem
                testId={'settings-button'}
                to={buildSettings(selectedPortal)}
                icon={'settings-empty'}
                iconColor={'var(--color-icon-secondary)'}
              />
            </PermissionGates.HasAny>
          </OnlyAdminPortal>
        )}
        <HelpCenterButton />
        <NotificationsButton />
        <ProfileButton />
        <V1AccountsOnly>
          <>{isPortalUIToggleEnabled && <PortalPreviewButton />}</>
        </V1AccountsOnly>
        {!isOpen && <NewUiPreviewBanner isOpen={false} />}
      </MainNavBottomDiv>
    </div>
  );
};

export default MainNavBottom;
